import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { DQOIToolbarEvent } from '@app/cp/shared/models/DQOIToolbarEvent';
import { ToolbarEvent } from '@app/cp/shared/enums/ToolbarEvent';

import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DQOIState } from '@app/cp/shared/models/DQOIState';
import { QuotesComponent } from '@app/cp/quotes/quotes.component';
import { OrdersComponent } from '@app/cp/orders/orders.component';
import { InvoicesComponent } from '@app/cp/invoices/invoices.component';
import { DQOIItem } from '@app/cp/shared/models/DQOIItem';
import { DQOIMessage } from '@app/cp/shared/models/DQOIMessage';
import { DQOIDisplayItem } from '@app/cp/shared/models/DQOIDisplayItem';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { DQOIParam } from '@app/cp/shared/models/DQOIParam';
import { OrderMessageInfo } from '@app/cp/shared/models/OrderMessageInfo';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { ConstructionJobsComponent } from '@app/cp/construction/jobs/construction-jobs.component';
import { ConstructionContractsComponent } from '../contracts/construction-contracts.component';
import { DispatchSaveParam } from '@app/cp/shared/models/DispatchSaveParam';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { ConstructionLandingComponent } from '../construction-landing/construction-landing.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { AppClaims } from '@app/cp/shared/models/AppClaims';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { CmProAuthService } from '@app/core/services';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { DispatchData } from '../../shared/models/DispatchData';

@UseCPLoader()
@Component({
    selector: 'cboi',
    templateUrl: './cboi.component.html',
    styleUrls: ['./cboi.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CBOIComponent implements OnInit, OnDestroy {
    compLoader: ICPLoader = this as any;
    @ViewChild('dqoiTabStrip') public tabstrip: TabStripComponent;
    @ViewChild('cboiContract') public cboiContract: ConstructionContractsComponent;
    @ViewChild('cboiJob') public cboiJob: ConstructionJobsComponent;
    @ViewChild('dqoiQuote') public dqoiQuote: QuotesComponent;
    @ViewChild('dqoiOrder') public dqoiOrder: OrdersComponent;
    @ViewChild('dqoiInvoice') public dqoiInvoice: InvoicesComponent;
    @ViewChild('dqoiConstructionLanding') public dqoiConstructionLanding: ConstructionLandingComponent;

    protected _id: any;
    @Input() set id(id: any) {
                    if (CommonFunctions.hasStringValue(id)) {
                        this.setupFromId(id);
                    }
                }
    @Input() target: string = "D";
    @Input() dqoiDispatchSettings: DispatchData = null;

    @Input() set DQOIInput(item: DQOIItem) {
        if (!CommonFunctions.hasValue(this.dqoiItem) || (CommonFunctions.hasValue(item) && this.searchOperatingMode == 2)) {
            this.dqoiItem = item;
            this.setup(item);
        }
    }
    @Input() searchOperatingMode: number = 1; //2-Multiple searches

    @Output() dqoiMessage: EventEmitter<DQOIMessage> = new EventEmitter<DQOIMessage>();
    logo: any;
    sendDQOIMessage(message: DQOIMessage) {
        this.dqoiMessage.emit(message);

    }
    get hasLogo(): boolean {
        return CommonFunctions.hasValue(this.logo);
    }

    onDQOIMessage(e: DQOIMessage) {
        if (e.messageType === MessageType.customerAndLocation) {
            this.displayItem.customer = e.customer;
            this.displayItem.location = e.location;
            if (this.showDirty && !this.cboiContract.isDirty && !this.cboiJob.isDirty && !this.dqoiQuote.isDirty && !this.dqoiInvoice.isDirty) { this.showDirty = false;}
            if (CommonFunctions.hasValue(e.customerId)) {
                this.svc_cust.getLogo(e.customerId).subscribe(blob => {
                    this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
                });
            }
            else {
                this.logo = null;
            }
        }
        else if (e.messageType === MessageType.createOrderFromParts) {
            this.createOrderFromParts(e.messageData);
        }
        else if (e.messageType === MessageType.goTo) {
            this.goTo(e.messageData);
        }
        else if (e.messageType === MessageType.createOrderFromJob) {
            this.createOrderFromJob(e.messageData);
        }
        else if (e.messageType === MessageType.disableMainTabs) {
            this.mainTabsEnabled = false;
            this.cd.detectChanges();
        }
        else if (e.messageType === MessageType.enableMainTabs) {
            this.mainTabsEnabled = true;
            this.cd.detectChanges();
        }
        else if (e.messageType === MessageType.childSaved) {
            this.sendDQOIMessage(e);
            this.cd.detectChanges();
        }
    }
    contractEnabled: boolean = true;
    mainTabsEnabled: boolean = true;
    displayItem: DQOIDisplayItem = new DQOIDisplayItem();
    dqoiItem: DQOIItem = null;
    get hasDQOIItem(): boolean {
        return CommonFunctions.hasValue(this.dqoiItem);
    }
    get dqoiIndex(): number {
        return this.hasDQOIItem ? this.dqoiItem.index : -1;
    }
    getDQOIItem() : DQOIItem {
        let item: DQOIItem = null;
        if (this.hasDQOIItem) {
            item = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        }
        return item;
    }
    searchTarget: SearchTarget = SearchTarget.dispatch;
    subs_toolbarEvent: Subscription;
    readOnly: boolean = true;
    hasData: boolean = false;
    showDirty: boolean = false;
    get highlightDirty(): boolean {
        return (this.showDirty && (this.cboiContract.isDirty || this.cboiJob.isDirty || this.dqoiQuote.isDirty || this.dqoiInvoice.isDirty));
    }
    get canEdit(): boolean {
        return this.readOnly && this.hasData;
    }
    get canClear(): boolean {
        return this.readOnly && this.hasData;
    }
    constructor(private elementRef: ElementRef<HTMLElement>, globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_dqoi: DQOIService, private svc_cust: CustomerService, private sanitizer: DomSanitizer, private svc_dispatch: DispatchesService, private cd: ChangeDetectorRef, private authService: CmProAuthService) {

    }
    scrollIntoView() {
        this.elementRef.nativeElement.scrollIntoView(true);
    }
    priorityClass() {
        let id: string = '';
        if (CommonFunctions.hasValue(this.dqoiItem)) {
            id = CommonFunctions.getStringValueIfNull(this.dqoiItem.priorityId, '').toUpperCase();
        }
        switch (id) {
            case '3FE257A3-0F32-4C46-8424-8AC3B979D3A8': return 'dqoi-panel-priority priority overtime-approval'; // Overtime Approved
            case '82BB9C7E-6FE5-4772-B10E-591148698068': return 'dqoi-panel-priority priority hot-parts'; // HOT PARTS - ASAP
            case '8DF31E86-C0BD-4340-852F-41BFBC07937B': return 'dqoi-panel-priority priority high'; // High
            case 'F76D9D14-18D3-4931-87DF-A63EE4E526BD': return 'dqoi-panel-priority priority normal'; // Normal
            case '9B33B03A-3418-4335-B3F1-0E95E772A895': return 'dqoi-panel-priority priority pm'; // PM
            case 'F96B1A29-BA30-469E-84FD-8937A3D8CAF4': return 'dqoi-panel-priority priority warranty'; // Warranty (Hot)
            case 'DD87160B-0775-4DAD-B070-D9021D099F3D': return 'dqoi-panel-priority priority locked-scheduled'; // LOCKED - SCHEDULED
            case '3225ADA7-56A5-49C2-88D2-D3403340B8F8': return 'dqoi-panel-priority priority'; // Special Equipment
            default: return 'dqoi-panel-priority priority';
        }
    }

    removeDQOI() {
        let message: DQOIMessage = new DQOIMessage();
        message.messageType = MessageType.close;
        message.messageData = this.dqoiItem.index;
        if (CommonFunctions.hasValue(this.cboiContract)) {
            this.cboiContract.close();
        }
        if (CommonFunctions.hasValue(this.cboiJob)) {
//            this.cboiJob.close();
        }
        if (CommonFunctions.hasValue(this.dqoiQuote)) {
            this.dqoiQuote.close();
        }
        if (CommonFunctions.hasValue(this.dqoiOrder)) {
            this.dqoiOrder.close();
        }
        if (CommonFunctions.hasValue(this.dqoiInvoice)) {
            this.dqoiInvoice.close();
        }
        this.sendDQOIMessage(message);
    }
    rights: AppClaims = new AppClaims();
    ngOnInit() {
        this.subs_toolbarEvent = this.svc_dqoi.toolbarEvent$.subscribe((data: DQOIToolbarEvent) => {
            if (data !== null && data.isToolbarOnly) {
                this.hasData = data.hasData;
                this.readOnly = data.readOnly;
            }
        });
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });
    }
    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
    }

    expandedSearch: boolean = false;

    getTargetFromId(id: string): SearchTarget {
        let target: SearchTarget = SearchTarget.any;
        let arr = id.split(":");
        if (CommonFunctions.hasArrayElementValue(arr)) {
            switch (arr[0]) {
                case "1":
                    target = SearchTarget.dispatch;
                    break;
                case "2":
                    target = SearchTarget.quote;
                    break;
                case "3":
                    target = SearchTarget.order;
                    break;
                case "4":
                    target = SearchTarget.invoice;
                    break;

            }
        }
        return target;
    }
    setupFromId(id: any) {
        //let t_id: string = target + ":" + id; //"7b13a2d3-c952-4528-826e-37e38b52bcd4";

        this.svc_dispatch.getDQOIItem(id).subscribe((data: DQOIItem) => {
            data.searchTarget = this.getTargetFromId(id);
            data.index = 1;
            this.setup(data);
        });

    }
    setup(data: DQOIItem) {

        let se: DQOISearchEvent = new DQOISearchEvent();
        if (CommonFunctions.hasValue(data)) {
            let tempDQOI = this.svc_dqoi.getDQOIItem(data.index);
            if (!CommonFunctions.hasValue(tempDQOI)) {
                this.dqoiItem = new DQOIItem(data);
                this.svc_dqoi.setDQOIItem(data);
            }
            this.searchTarget = data.searchTarget;
            se.isNew = this.dqoiItem.isNew;
            console.log("cboi-setup:", this.dqoiItem);
            se.searchTarget = data.searchTarget;
            se.dispatchId = data.dispatchId;
            se.dqoiItem = data;
            switch (data.searchTarget) {
                case SearchTarget.contract:
                    break;
                case SearchTarget.job:
                    break;
                case SearchTarget.quote:
                    se.quoteNumber = data.number;
                    //this.tabstrip.selectTab(1);
                    break;
                case SearchTarget.order:
                    se.orderNumber = data.number;
                    se.id = data.orderId;
                    //this.tabstrip.selectTab(2);
                    break;
                case SearchTarget.invoice:
                    se.invoiceNumber = data.number;
                    //this.tabstrip.selectTab(3);
                    break;
            }
        }
        this.svc_dqoi.nextSearchEvent(se);
    }

    get contractTitle(): string {
        return 'Contract'; //this.hasDQOIItem && this.dqoiItem.hasDispatch ? 'Contract' : 'Create Dispatch';
    }
    get jobTitle(): string {
        return 'Job'; //this.hasDQOIItem && this.dqoiItem.hasQuote ? 'Quote' : 'Create Quote';
    }
    get quoteTitle(): string {
        return 'Bid'; //this.hasDQOIItem && this.dqoiItem.hasQuote ? 'Quote' : 'Create Quote';
    }
    get orderTitle(): string {
        return 'Orders'; //this.hasDQOIItem && this.dqoiItem.hasOrder ? 'Order' : 'Create Order';
    }
    get invoiceTitle(): string {
        return 'Invoice'; //this.hasDQOIItem && this.dqoiItem.hasInvoice ? 'Invoice' : 'Create Invoice';
    }

    get landingTitle(): string {
        return 'Landing'; //this.hasDQOIItem && this.dqoiItem.hasInvoice ? 'Invoice' : 'Create Invoice';
    }

    protected getFromId(fromTarget: SearchTarget, item: DQOIItem): any {
        let fromId: any = null;
        switch (fromTarget) {
            case SearchTarget.dispatch:
                fromId = item.dispatchId;
                break;
            case SearchTarget.quote:
                fromId = item.quoteId;
                break;
            case SearchTarget.order:
                fromId = item.orderId;
                break;
            case SearchTarget.invoice:
                fromId = item.invoiceId;
                break;
        }
        return fromId;
    }
    setTab(code: string, e) {
        let dqoiState: DQOIState = this.svc_dqoi.getDQOIState();
        let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiItem.index);
        let currSearchTarget: SearchTarget = this.searchTarget;
        let fromId: any = this.getFromId(currSearchTarget, item);
        console.log("cboi-settab: ", item, this.dqoiItem, dqoiState);
        if (!this.selectingTabProgramatically && CommonFunctions.hasValue(item)) {
            switch (code.toUpperCase()) {
                case "CONTRACT":
                    this.searchTarget = SearchTarget.contract;
                    this.cboiContract.checkChange(item.index, SearchTarget.contract);
                    this.cboiContract.getConstructionBidStatus();
                    break;
                case "JOB":
                    this.searchTarget = SearchTarget.job;

                    this.cboiJob.checkChange(item.index, SearchTarget.job);
                    break;
                case "BID":
                    this.searchTarget = SearchTarget.quote;
                    this.dqoiQuote.checkChange(item.index, SearchTarget.quote);
                    break;
                case "ORDERS":
                    this.searchTarget = SearchTarget.order;
                    this.dqoiOrder.checkChange(item.index, SearchTarget.order);
                    break;
                case "INVOICE":
                    this.searchTarget = SearchTarget.invoice;
                    this.dqoiInvoice.checkChange(item.index, SearchTarget.invoice);
                    break;
                case "LANDING":
                    this.searchTarget = SearchTarget.landing;
                    this.dqoiConstructionLanding.getData();
                    break;
            }
            //            this.selectingTabProgramatically = false;
        }
        else {
            if (this.selectingTabProgramatically) {
                switch (code.toUpperCase()) {
                    case "CONTRACT":
                        this.searchTarget = SearchTarget.contract;
                       break;
                    case "JOB":
                        this.searchTarget = SearchTarget.job;
                        break;
                    case "BID":
                        this.searchTarget = SearchTarget.quote;
                        break;
                    case "ORDERS":
                        this.searchTarget = SearchTarget.order;
                        break;
                    case "INVOICE":
                        this.searchTarget = SearchTarget.invoice;
                        break;
                    case "LANDING":
                        this.searchTarget = SearchTarget.landing;
                        this.dqoiConstructionLanding.getData();
                        break;
                }
            }
            this.selectingTabProgramatically = false;
        }
    }
    selectingTabProgramatically: boolean = false;
    getTabIndexFromTarget(target: SearchTarget) {
        let tabIndex: number = 0;
        switch (target) {
            case SearchTarget.contract:
                break;
            case SearchTarget.dispatch:
                break;
            case SearchTarget.job:
                tabIndex = 1;
                break;
            case SearchTarget.quote:
                tabIndex = 2;
                break;
            case SearchTarget.order:
                tabIndex = 3;
                break;
            case SearchTarget.invoice:
                tabIndex = 4;
                break;
            case SearchTarget.landing:
                tabIndex = 5;
                break;
        }
        return tabIndex;
    }
    createQuote() {

    }
    setToolbar() {

    }
    onTabSelect(e: any, tabstrip: any ) {
        this.setTab(e.title,e);
    }
    new() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.new, readOnly: false, hasData: true, data: null, index: null});
        this.readOnly = false;
    }
    edit() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.edit, readOnly: false, hasData: true, data: null, index: null});
        this.readOnly = false;
    }
    save() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.save, readOnly: true, hasData: true, data: null, index: null });
        this.readOnly = true;
    }
    cancel() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.cancel, readOnly: true, hasData: true, data: null, index: null});
        this.readOnly = true;
    }
    clear() {
        this.svc_dqoi.nextToolbarEvent({ isToolbarOnly: false, searchTarget: this.searchTarget, toolbarEvent: ToolbarEvent.clear, readOnly: true, hasData: false, data: null, index: null });
        this.readOnly = true;
    }
    addNote() {

    }
    handleFilter(filter: string) {
    }
    public testValue: string = "";
    public listItems: Array<string> = ["Baseball", "Basketball", "Cricket", "Field Hockey", "Football", "Table Tennis", "Tennis", "Volleyball", "Table Jacks"];

    panelOpened() {

    }
    panelClosed() {

        this.cboiContract.reduceToMinData();
        this.cboiJob.reduceToMinData();
        this.dqoiQuote.reduceToMinData();
        this.dqoiOrder.reduceToMinData();
        this.dqoiInvoice.reduceToMinData();
    }

    goTo(data: DQOIParam) {
        let index: number = 0;
        var tempBool = this.mainTabsEnabled;

        switch (data.target) {
            case SearchTarget.contract:

                this.cboiContract.setDQOIIndex(this.dqoiItem.index);
                this.cboiContract.setup(data, data.code);
                index = this.getTabIndexFromTarget(SearchTarget.contract);
                this.selectingTabProgramatically = true;
                this.mainTabsEnabled = true;
                this.cd.detectChanges();
                this.tabstrip.selectTab(index);

                break;
            case SearchTarget.job:

                this.cboiJob.setDQOIIndex(this.dqoiItem.index);
                this.cboiJob.setup(data, data.code);
                index = this.getTabIndexFromTarget(SearchTarget.job);
                this.selectingTabProgramatically = true;
                this.mainTabsEnabled = true;
                this.cd.detectChanges();
                this.tabstrip.selectTab(index);

                break;
            case SearchTarget.quote:
                this.dqoiQuote.setDQOIIndex(this.dqoiItem.index);
                this.dqoiQuote.setup(data, data.code);
                index = this.getTabIndexFromTarget(SearchTarget.quote);
                this.selectingTabProgramatically = true;
                this.mainTabsEnabled = true;
                this.cd.detectChanges();
                this.tabstrip.selectTab(index);

                break;
            case SearchTarget.order:
                this.dqoiOrder.setDQOIIndex(this.dqoiItem.index);
                this.dqoiOrder.setup(data, data.code);
                index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.mainTabsEnabled = true;
                this.cd.detectChanges();
                this.tabstrip.selectTab(index);

                break;
            case SearchTarget.invoice:
                this.dqoiInvoice.setDQOIIndex(this.dqoiItem.index);
                this.dqoiInvoice.setup(data, data.code);
                // BJB - Removed because this sets only tx contracts to exempt avalara and that is old logic.
                //this.canSelectAvalarST();
                index = this.getTabIndexFromTarget(SearchTarget.invoice);
                this.selectingTabProgramatically = true;
                this.mainTabsEnabled = true;
                this.cd.detectChanges();
                this.tabstrip.selectTab(index);
                break;
            case SearchTarget.landing:
                this.dqoiConstructionLanding.getData();
                this.selectingTabProgramatically = true;
                this.mainTabsEnabled = true;
                this.cd.detectChanges();
                this.tabstrip.selectTab(index);
                break;
        }
        if (this.mainTabsEnabled != tempBool) {
            this.mainTabsEnabled = tempBool;
            this.cd.detectChanges();
        }
    }
    canSelectAvalarST():void{
        this.dqoiInvoice.invoiceFromConstruction();
    }
    createOrderFromParts(data: any) {
        this.compLoader.cpLoaderOn();
        let param: DispatchSaveParam = new DispatchSaveParam(null);
        param.partsReq = data;

        this.svc_dqoi.createNewFromDispatchPartsReq(param).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMQUOTE";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiOrder.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
        });
        this.compLoader.cpLoaderOff();
    }
    createOrderFromJob(param: CommonParam) {
        this.compLoader.cpLoaderOn();
        this.svc_dqoi.createNewOrderFromJob(param.dcParams.jobId, param.dcParams.isSubPO).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                let param: DQOIParam = new DQOIParam();
                param.code = "CRFROMJOB";
                param.data = info;
                param.dqoiItem = this.getDQOIItem(); // this.dqoiItem;
                this.dqoiOrder.setup(param, param.code);
                let index = this.getTabIndexFromTarget(SearchTarget.order);
                this.selectingTabProgramatically = true;
                this.tabstrip.selectTab(index);
            }
        });
        this.compLoader.cpLoaderOff();
    }
}
